<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card class="md-card-plain">
          <md-card-header data-background-color="red">
            <h4 class="title">Finder List</h4>
            <p class="category">List of all the users</p>
          </md-card-header>
          <md-card-content>
            <finder-table table-header-color="green"></finder-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
  import FinderTable from '@/components/Tables/FinderTable.vue'

  export default{
    components: {
      FinderTable
    }
  }
</script>
<style>
  .md-dialog{
    transform: translate3d(-330px, -305px, 0px) scale(1) !important;
  }

  @media only screen and (max-width: 600px) {
    .md-dialog{
      transform: none !important;
      max-height: 75% !important;
    }
    .md-layout{
      overflow-y: scroll !important;
    }
  }
</style>
